import { z } from "zod";

export const AuthUserSchema = z.object({
	id: z.string().cuid(),
	email: z.string().email(),
	name: z.string().nullable().optional(),
	plan: z.enum(["FREE", "BASIC", "PRO", "ENTERPRISE"]),
	gyulBalance: z.number().int(),
});

export const RegisterRequestSchema = z.object({
	email: z.string().email(),
	password: z.string(),
	name: z.string().optional(),
});

export const RegisterResponseSchema = z.object({
	success: z.boolean(),
	requiresVerification: z.boolean().optional(),
	accessToken: z.string().optional(),
	refreshToken: z.string().optional(),
	user: AuthUserSchema.optional(),
});

export const LoginRequestSchema = z.object({
	email: z.string().email(),
	password: z.string(),
});

export const LoginResponseSchema = z.object({
	accessToken: z.string(),
	refreshToken: z.string(),
	user: AuthUserSchema,
});

export const RefreshTokenRequestSchema = z.object({
	refreshToken: z.string(),
});

export const RefreshTokenResponseSchema = z.object({
	accessToken: z.string(),
});

export const VerifyEmailRequestSchema = z.object({
	email: z.string().email(),
	code: z.string().length(6),
});

export const VerifyEmailResponseSchema = z.object({
	success: z.boolean(),
	accessToken: z.string().optional(),
	refreshToken: z.string().optional(),
	user: AuthUserSchema.optional(),
});

export const ResendVerificationRequestSchema = z.object({
	email: z.string().email(),
});

export const ResendVerificationResponseSchema = z.object({
	success: z.boolean(),
});

export const LogoutResponseSchema = z.object({
	success: z.boolean(),
});

export type AuthUser = z.infer<typeof AuthUserSchema>;
export type RegisterRequest = z.infer<typeof RegisterRequestSchema>;
export type RegisterResponse = z.infer<typeof RegisterResponseSchema>;
export type LoginRequest = z.infer<typeof LoginRequestSchema>;
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
export type RefreshTokenRequest = z.infer<typeof RefreshTokenRequestSchema>;
export type RefreshTokenResponse = z.infer<typeof RefreshTokenResponseSchema>;
export type VerifyEmailRequest = z.infer<typeof VerifyEmailRequestSchema>;
export type VerifyEmailResponse = z.infer<typeof VerifyEmailResponseSchema>;
export type ResendVerificationRequest = z.infer<typeof ResendVerificationRequestSchema>;
export type ResendVerificationResponse = z.infer<typeof ResendVerificationResponseSchema>;
export type LogoutResponse = z.infer<typeof LogoutResponseSchema>;
